import { ActionReducerMapBuilder } from '@reduxjs/toolkit'

import { FOLLOW_REPLY_CHANNEL } from 'apps/followReply/constants'
import { FollowReplyState } from 'apps/followReply/interfaces'
import { getChannelState, NAMESPACE } from 'apps/followReply/store/constants'
import { followReplyApi } from 'shared/api/requests/followReply'
import { createAsyncAction } from 'shared/lib/redux'

export const removeFlow = createAsyncAction(`${NAMESPACE}/removeFlow`, async () => {
  const replacedFlowData = await followReplyApi.removeFlow()

  return replacedFlowData.data
})

export const removeFlowReducer = (builder: ActionReducerMapBuilder<FollowReplyState>) => {
  builder.addCase(removeFlow.fulfilled, (state, action) => {
    const data = action.payload
    state[FOLLOW_REPLY_CHANNEL] = getChannelState(data)
  })
}
